import React, { useEffect, useState } from 'react';
import DashboardHeaderItem from '../../../components/dashboardheader';
import TotalProduction from '../../../assets/images/TotalProductionDisactive.svg';
import TotalInstalled from '../../../assets/images/TotalInstalled.svg';
import TotalAlert from '../../../assets/images/TotalAlert.svg';
import TotalProductionActive from '../../../assets/images/TotalProduction.svg';
import TotalInstalledActive from '../../../assets/images/TotalInstalledActive.svg';
import TotalAlertActive from '../../../assets/images/TotalAlertActive.svg';

import ManufactureUnit from './manufactureUnit';
import RegisterUnit from './registeredUnit';
import UnRegisterUnit from './unRegisteredUnit';
import { useHook as DashboardHook } from '../dashboard/useHook';
import { Unauthorized } from '../../../components/index';
import { ErrorMessage } from '../../../permissionErrorMessage/PermissionMessage';

interface Props {
  pagePermissionIDs: unknown;
}
const Inventory: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canlistManufacturedInventories =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('inventories::manufacturedInventories');
  const canlistUnregisteredInventories =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('inventories::unregisteredInventories');
  const canlistRegisteredInventories =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('inventories::registeredInventories');
  const canCategorylistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::list');
  const userRole = localStorage.getItem('role') || '';
  const [pageName, setPageName] = useState(
    userRole === 'dealer' ? 'unregistered' : 'manufactured',
  );
  const manufacturedInventoriesdAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['inventories::manufacturedInventories'] || ''}</li>
        <li>{ErrorMessage['categories::list'] || ''}</li>
      </ul>
    </section>
  );
  const unregisteredInventoriesAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['inventories::unregisteredInventories'] || ''}</li>
        <li>{ErrorMessage['categories::list'] || ''}</li>
      </ul>
    </section>
  );
  const registeredInventoriesAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['inventories::registeredInventories'] || ''}</li>
        <li>{ErrorMessage['categories::list'] || ''}</li>
      </ul>
    </section>
  );
  const {
    getManufacturedUnitsCount,
    getUnregisteredUnitsCount,
    getDealerUnregisteredUnitsCount,
    getRegisteredUnitsCount,
    getDealerRegisteredUnitsCount,
  } = DashboardHook();
  const handlePageRouteChange = (title: string) => {
    setPageName(title);
  };
  const [manufacturedTotalNo, setManufacturedTotalNo] = useState(0);
  const [registeredUnitsTotalNo, setRegisteredUnitsTotalNo] = useState(0);
  const [unRegisteredUnitsTotalNo, setUnRegisteredUnitsTotalNo] = useState(0);

  useEffect(() => {
    setManufacturedInventory();
    setRegisterInventory();
    setUnRegisterInventory();
  }, [
    canlistManufacturedInventories,
    canlistRegisteredInventories,
    canlistUnregisteredInventories,
    canCategorylistPermission,
  ]);
  const setManufacturedInventory = async () => {
    if (
      userRole !== 'dealer' &&
      canlistManufacturedInventories &&
      canCategorylistPermission
    ) {
      await getManufacturedUnitsCount().then((res: any) => {
        setManufacturedTotalNo(res || 0);
      });
    }
  };
  const setRegisterInventory = async () => {
    if (userRole === 'dealer') {
      await getDealerRegisteredUnitsCount().then((res: any) => {
        setRegisteredUnitsTotalNo(res || 0);
      });
    } else if (canlistRegisteredInventories && canCategorylistPermission) {
      await getRegisteredUnitsCount().then((res: any) => {
        setRegisteredUnitsTotalNo(res || 0);
      });
    }
  };
  const setUnRegisterInventory = async () => {
    if (userRole === 'dealer') {
      await getDealerUnregisteredUnitsCount().then((res: any) => {
        setUnRegisteredUnitsTotalNo(res || 0);
      });
    } else if (canlistUnregisteredInventories && canCategorylistPermission) {
      await getUnregisteredUnitsCount().then((res: any) => {
        setUnRegisteredUnitsTotalNo(res || 0);
      });
    }
  };
  const setters = {
    setManufacturedInventory: setManufacturedInventory,
    setUnRegisterInventory: setUnRegisterInventory,
    setRegisterInventory: setRegisterInventory,
  };
  return (
    <>
      <header className="dashboard_topheader">
        {userRole !== 'dealer' && (
          <DashboardHeaderItem
            iconSrc={
              pageName === 'manufactured'
                ? TotalProductionActive
                : TotalProduction
            }
            title="Manufactured Units"
            value={canlistManufacturedInventories ? manufacturedTotalNo : ''}
            id="manufactured"
            action={handlePageRouteChange}
            activeClass={pageName === 'manufactured' ? true : false}
          />
        )}

        <DashboardHeaderItem
          iconSrc={
            pageName === 'unregistered' ? TotalInstalledActive : TotalInstalled
          }
          title="Unregistered Units"
          value={canlistUnregisteredInventories ? unRegisteredUnitsTotalNo : ''}
          id="unregistered"
          action={handlePageRouteChange}
          activeClass={pageName === 'unregistered' ? true : false}
        />
        <DashboardHeaderItem
          iconSrc={pageName === 'registered' ? TotalAlertActive : TotalAlert}
          title="Registered Units"
          value={canlistRegisteredInventories ? registeredUnitsTotalNo : ''}
          id="registered"
          action={handlePageRouteChange}
          activeClass={pageName === 'registered' ? true : false}
        />
      </header>

      {pageName === 'manufactured' ? (
        canlistManufacturedInventories && canCategorylistPermission ? (
          <ManufactureUnit
            setters={setters}
            pagePermissionIDs={pagePermissionIDs}
          />
        ) : (
          <Unauthorized requiredAccess={manufacturedInventoriesdAccess} />
        )
      ) : pageName === 'unregistered' ? (
        canlistUnregisteredInventories && canCategorylistPermission ? (
          <UnRegisterUnit pagePermissionIDs={pagePermissionIDs} />
        ) : (
          <Unauthorized requiredAccess={unregisteredInventoriesAccess} />
        )
      ) : pageName === 'registered' ? (
        canlistRegisteredInventories && canCategorylistPermission ? (
          <RegisterUnit pagePermissionIDs={pagePermissionIDs} />
        ) : (
          <Unauthorized requiredAccess={registeredInventoriesAccess} />
        )
      ) : (
        <></>
      )}
    </>
  );
};

export default Inventory;
